import styled from "styled-components";

import { ReactComponent as BasketImage } from "./basket.svg";

export const BasketIcon = styled(BasketImage)`
  width: 180px;
  height: 164px;
`;
